/*=========================================================================================
  File Name: moduleNoteState.js
  Description: Note Module State
==========================================================================================*/

export const getDefaultState = () => {
	return {
		posts: [],
		total: 0,
		limitPerPage: 5,
		isHasMorePages: null,
		appellations: [],
		featurePosts: []
	};
};

export default getDefaultState();
